import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './TermsLink.scss';

interface ITermsLinkProps {
  label: Partial<string>;
  url: string;
  target?: '_blank' | '_self';
  variant?: 'inline' | 'block';
}

const TermsLink = (props: ITermsLinkProps) => {
  const { label, url, target, variant } = props;

  const wrapperClassNames = cx({
    [Styles.wrapper]: true,
    [Styles.inline]: variant === 'inline',
    [Styles.block]: variant === 'block',
  });

  return (
    <div className={wrapperClassNames}>
      <a className={Styles.link} target={target ? target : '_blank'} href={url}>{label}</a>
    </div>
  );
};

export default TermsLink;
